assert.notEqual = notEqual;
assert.notOk = notOk;
assert.equal = equal;
assert.ok = assert;
module.exports = assert;
function equal(a, b, m) {
}
function notEqual(a, b, m) {
}
function notOk(t, m) {
}
function assert(t, m) {
    if (!t)
        throw new Error(m || 'AssertionError');
}